import axios from 'axios';

export const GET_FUND_TRANSFERS_SUCCESS = 'GET_FUND_TRANSFERS_SUCCESS';
export const GET_FUND_TRANSFER_DETAILS_SUCCESS = 'GET_FUND_TRANSFER_DETAILS_SUCCESS';
export const GET_REALTIME_BALANCES_SUCCESS = 'GET_REALTIME_BALANCES_SUCCESS';
export const FUND_TRANSFER_LOADING = 'FUND_TRANSFER_LOADING';
export const FUND_TRANSFER_ERROR = 'FUND_TRANSFER_ERROR';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorised: token,
      Authorization: `Bearer ${token}`
    }
  };
};

// 1. Récupérer les transferts avec filtres
export const getFundTransfers = (filters = {}) => async (dispatch) => {
  dispatch({ type: FUND_TRANSFER_LOADING });
  try {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.transferType) params.append('transferType', filters.transferType);
    if (filters.location) params.append('location', filters.location);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.search) params.append('search', filters.search);

    const res = await axios.get(`/api/fund-transfers?${params.toString()}`, getAuthHeaders());
    dispatch({
      type: GET_FUND_TRANSFERS_SUCCESS,
      payload: res.data.transfers || []
    });
  } catch (error) {
    console.error('❌ Erreur getFundTransfers:', error);
    dispatch({
      type: FUND_TRANSFER_ERROR,
      payload: error.response?.data?.msg || 'Erreur lors du chargement des transferts'
    });
  }
};

// 2. Récupérer les soldes en temps réel
export const getRealtimeBalances = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/fund-transfers/balances/realtime', getAuthHeaders());
    dispatch({
      type: GET_REALTIME_BALANCES_SUCCESS,
      payload: res.data
    });
  } catch (error) {
    console.error('❌ Erreur getRealtimeBalances:', error);
  }
};

// 3. Créer un nouveau transfert / enregistrement de collecte
export const createFundTransfer = (transferData, onSuccess) => async (dispatch) => {
  dispatch({ type: FUND_TRANSFER_LOADING });
  try {
    const res = await axios.post('/api/fund-transfers', transferData, getAuthHeaders());
    dispatch(getFundTransfers());
    dispatch(getRealtimeBalances());
    if (onSuccess) onSuccess(res.data.transfer);
    return { success: true, transfer: res.data.transfer };
  } catch (error) {
    const errorMsg = error.response?.data?.msg || 'Erreur lors de la création du transfert';
    dispatch({ type: FUND_TRANSFER_ERROR, payload: errorMsg });
    return { success: false, error: errorMsg };
  }
};

// 4. Confirmer la réception (par PIN ou scan QR)
export const confirmFundReception = (transferId, confirmationData, onSuccess) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/fund-transfers/${transferId}/confirm-reception`, confirmationData, getAuthHeaders());
    dispatch(getFundTransfers());
    dispatch(getRealtimeBalances());
    if (onSuccess) onSuccess(res.data.transfer);
    return { success: true, transfer: res.data.transfer };
  } catch (error) {
    const errorMsg = error.response?.data?.msg || 'Erreur lors de la confirmation de réception';
    return { success: false, error: errorMsg };
  }
};

// 5. Convertir les pièces en billets
export const convertCoinsToBills = (transferId, conversionData, onSuccess) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/fund-transfers/${transferId}/convert-coins`, conversionData, getAuthHeaders());
    dispatch(getFundTransfers());
    dispatch(getRealtimeBalances());
    if (onSuccess) onSuccess(res.data.transfer);
    return { success: true, transfer: res.data.transfer };
  } catch (error) {
    const errorMsg = error.response?.data?.msg || 'Erreur lors de la conversion des pièces';
    return { success: false, error: errorMsg };
  }
};

// 6. Rejeter ou annuler
export const rejectOrCancelTransfer = (transferId, data, onSuccess) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/fund-transfers/${transferId}/reject-cancel`, data, getAuthHeaders());
    dispatch(getFundTransfers());
    dispatch(getRealtimeBalances());
    if (onSuccess) onSuccess(res.data.transfer);
    return { success: true, transfer: res.data.transfer };
  } catch (error) {
    const errorMsg = error.response?.data?.msg || 'Erreur lors de l\'annulation / rejet';
    return { success: false, error: errorMsg };
  }
};

// 7. Vérifier un code PIN
export const verifyPinCode = async (pinCode) => {
  try {
    const res = await axios.post('/api/fund-transfers/verify-pin', { pinCode }, getAuthHeaders());
    return res.data;
  } catch (error) {
    return { success: false, msg: error.response?.data?.msg || 'Code PIN invalide' };
  }
};
